module.exports = __webpack_public_path__ + "static/gsch1-840a09117c0c079afa1fea7593cd88ba.jpg";